/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessTypeModel {
        service: services.ProcessTypeService;
        processTypes: Wars.Domain.Model.ProcessType[] = [];
        childProcessTypes: Wars.Domain.Model.ProcessType[];
        hasChanges = false;
        showRemoveConfirmation = false;
        selectedIndex = undefined;
        public search: any;

        public processTypeContext: models.EnumDropDownContext = new EnumDropDownContext();

        constructor(
            processTypeService: services.ProcessTypeService,
            private locationService: angular.ILocationService,
            private dataSourceService: services.DataSourceService,
            private processConfigurationService: services.ProcessConfigurationService,
            private deleteService: services.DeleteService,
            public processConfigurationId?: string) {

            var self = this;

            this.search = {
                name: ''
            }

            var stringValueInLocalStorage = localStorage.getItem("processTypeFilter");
            if (stringValueInLocalStorage) {
                this.search.name = stringValueInLocalStorage;
            }

            this.service = processTypeService;
            this.service.subscribeHasChanges(e => {
                this.hasChanges = e.hasChanges;
            });

            if (processConfigurationId) {
                this.service.getConfigurationChildProcesses(processConfigurationId)
                    .then(data => {
                        this.processTypes = data;
                    });
                this.service.getChildProcessTypes()
                    .then(data => {
                        this.childProcessTypes = data;
                    });
            } else {
                this.service.getAllProcessTypes()
                    .then(data => {
                        this.processTypes = data;
                    });
            }

            this.processTypeContext.removeSpecifiedOptions = [];
            this.processTypeContext.removeSpecifiedOptions.push();
        }

        public saveFilterToLocalStorage() {
            localStorage.setItem("processTypeFilter", this.search.name);
        }

        private isEntityDetached(entity: breeze.Entity): boolean {
            if (entity.entityAspect.entityState.isDetached()) {
                return true;
            }

            return false;
        }

        private isEntityDeleted(entity: breeze.Entity): boolean {
            if (entity.entityAspect.entityState.isDeleted()) {
                return true;
            }

            return false;
        }

        private removeDetachedEntities(entities): void {
            var entitiesToRemove = [];
            for (var i = 0; i < entities.length; i++) {
                if (this.isEntityDetached(entities[i])) {
                    entitiesToRemove.push(entities[i]);
                }
            }

            for (var x = 0; x < entitiesToRemove.length; x++) {
                entities.pop(entitiesToRemove[x]);
                console.info(entitiesToRemove[x]);
            }
        }

        public addSingleInstanceNew() {
            this.addNewInternal(false, true, false);
        }

        public addReportNew() {
            this.addNewInternal(true, false, false);
        }

        public addNewTransient() {
            this.addNewInternal(false, false, true);
        }

        public addNew(processType?: Wars.Domain.Model.ProcessType): void {
            this.addNewInternal(false, false, false, processType);
        }


        private addNewInternal(isReport: boolean, isSingle: boolean,isTransient?:boolean, processType?: Wars.Domain.Model.ProcessType): void {
            let newProcessType: Wars.Domain.Model.ProcessType = null;
            if (!processType) {
                newProcessType = this.service.createProcessType();
                newProcessType.name = "New Process";
                newProcessType.isEmbedded = false;
                newProcessType.isReportProcess = isReport;
                newProcessType.isSingleInstanceProcess = isSingle;
                newProcessType.isTransient = isTransient;
            }

            if (this.processConfigurationId) {
                var newChildProcess = this.service.createChildProcess();

                newChildProcess.processConfiguration_id = this.processConfigurationId;

                if (!processType && newProcessType) {
                    newProcessType.isEmbedded = true;
                    newProcessType.isReportProcess = true;
                    newChildProcess.processType_id = newProcessType.id;
                    newChildProcess.processType = newProcessType;
                } else if (processType) {
                    newChildProcess.processType_id = processType.id;
                    newChildProcess.processType = processType;
                    this.processTypes.push(processType);
                }
            }

            if (newProcessType) {
                let newProcessConfiguration = this.service.createProcessConfiguration(newProcessType);
                newProcessConfiguration.configurationStatus = Wars.Domain.Model.Codes.Enums.ConfigurationStatus.InWork;
                newProcessType.processConfigurations.push(newProcessConfiguration);
                this.processTypes.push(newProcessType);
            }
            this.save();
        }

        public deleteLinkClicked(index: number): void {
            this.selectedIndex = index;
            this.showRemoveConfirmation = true;
        }

        public copyProcessType(index: number): void {
            this.service.copyProcessType(this.processTypes[index].id).then(
                () => {
                    this.service.getAllProcessTypes()
                        .then(data => {
                            this.processTypes = data;
                        });
                });
        }

        public remove(): void {
            window.open("https://youtu.be/V_IFRPkTWGg","_blank");
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ProcessType",
                this.processTypes[this.selectedIndex].id,
                "Process Type",
                () => {
                    this.processTypes.splice(this.selectedIndex, 1);
                    this.showRemoveConfirmation = false;
                    this.selectedIndex = undefined;
                });
        }

        public save(): void {
            this.service.saveAllChanges();
        }

        public configure(processType: Wars.Domain.Model.ProcessType, configuration?: Wars.Domain.Model.ProcessConfiguration): void {
            var configurationId;
            if (configuration) {
                configurationId = configuration.id;
            } else {
                
                configurationId = Enumerable.from(processType.processConfigurations)
                    .where(x => x.minorVersion === null)
                    .single().id;
            }

            this.locationService.path('ProcessConfiguration/' + configurationId + '/Manage');
        }
    }
}